export type LocalPlayErrorKind =
  | 'fda_permission_required'
  | 'outside_library_roots'
  | 'file_not_found'
  | 'generic';

export interface ClassifiedLocalPlayError {
  kind: LocalPlayErrorKind;
  raw: string;
}

export function classifyLocalPlayError(errMsg: string): ClassifiedLocalPlayError {
  const raw = String(errMsg || '').trim();
  const lower = raw.toLowerCase();

  if (raw.includes('fda_permission_required') || lower.includes('"kind":"fda_permission_required"')) {
    return { kind: 'fda_permission_required', raw };
  }
  if (
    lower.includes('outside configured library')
    || lower.includes('outside all library sources')
    || lower.includes('access denied: file is outside')
  ) {
    return { kind: 'outside_library_roots', raw };
  }
  if (
    lower.includes('not found')
    || lower.includes('no such file')
    || lower.includes('file_not_found')
    || lower.includes('does not exist on disk')
  ) {
    return { kind: 'file_not_found', raw };
  }
  return { kind: 'generic', raw };
}

export function dispatchFdaPermissionRequired(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('maestro:fda-required', { detail: { reason: 'play' } }));
}

export function openFdaSettings(): void {
  const tauri = (window as any).__TAURI__;
  const invoke = tauri?.core?.invoke || tauri?.invoke;
  if (invoke) {
    invoke('open_fda_settings').catch((e: unknown) => {
      console.error('[FDA] open_fda_settings failed:', e);
    });
  }
}
